import LoginSsoLoader from '@/pages/auth/new/LoginSSO';

function MicrosoftSsoButton({ isChecked, setShowError }) {
    return <LoginSsoLoader isChecked={isChecked} setShowError={setShowError} />;
}

export { MicrosoftSsoButton };
